import React from 'react';
import { comparison } from '../mock';
import { Check, X } from 'lucide-react';

export default function Comparison() {
  return (
    <section className="px-5 sm:px-8 mt-24">
      <div className="mx-auto max-w-[1100px]">
        <div className="pb-8 text-center">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
            <span className="tag-dot" /> Why TriMag
          </div>
          <h2 className="font-grotesk mt-3 text-4xl sm:text-5xl tracking-[-0.02em] font-medium">
            The <span className="font-display italic text-teal">difference</span> is in the details.
          </h2>
        </div>

        <div className="rounded-2xl border border-black/5 dark:border-white/5 overflow-hidden">
          <div className="grid grid-cols-3 items-center bg-neutral-50 dark:bg-neutral-900 px-6 py-4 text-[12px] uppercase tracking-widest text-neutral-500">
            <div>Feature</div>
            <div className="text-center text-teal font-semibold">Corevive TriMag</div>
            <div className="text-center">Ordinary Magnesium</div>
          </div>
          {comparison.rows.map((row, i) => (
            <div key={i} className={`grid grid-cols-3 items-center px-6 py-4 text-[14px] ${i % 2 === 0 ? '' : 'bg-neutral-50/60 dark:bg-neutral-950/40'} border-t border-black/5 dark:border-white/5`}>
              <div className="text-neutral-600 dark:text-neutral-400">{row[0]}</div>
              <div className="text-center font-medium flex items-center justify-center gap-1.5">
                {row[1] === 'Yes' ? (<><Check size={16} className="text-teal" /> Yes</>) : row[1]}
              </div>
              <div className="text-center text-neutral-500 flex items-center justify-center gap-1.5">
                {row[2] === 'No' ? (<><X size={16} className="text-neutral-400" /> No</>) : row[2]}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
